import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';

/**
 * QuizCardHeader - 퀴즈 카드의 헤더 섹션
 * EditableQuizCard/QuizCardUI.tsx (QuizCardHeader)에서 복사
 * @component
 */
const QuizCardHeader = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>((props, ref) => {
  const {
    children,
    className,
    ...rest
  } = props;
  return <div className={cn('flex items-center justify-center px-lg w-full min-h-[28px]', className)} ref={ref} {...rest}>
      {children}
    </div>;
});
QuizCardHeader.displayName = 'QuizCardHeader';
export { QuizCardHeader };